import type { ProjectProduct } from './types/projects.js';

/** subtotal = unitPrice * quantity; total = subtotal + tax + delivery. A pure function reused by
 * both the Lambda (for the /budget rollup) and the frontend (for display), so the two can never
 * drift on how a line item's total is computed. */
export function computeProductLineTotal(line: Pick<ProjectProduct, 'unitPrice' | 'quantity' | 'taxAmount' | 'delivery'>): {
  subtotal: number;
  total: number;
} {
  const subtotal = line.unitPrice * line.quantity;
  const total = subtotal + line.taxAmount + line.delivery;
  return { subtotal, total };
}
